export enum SystemNativeMethods {
  GO_TO_APP_SETTINGS_PAGE = 'ACCESS_SETTINGS_PAGE',
  PWA_READY = 'PWA_READY',
}
